import { VehicleCategory } from '@ekhodealer/ekho-common';

import {
	atvThumbnail,
	dirtThumbnail,
	dualSportThumbnail,
	golfThumbnail,
	mopedThumbnail,
	motorcycleThumbnail,
	orvThumbnail,
	scooterThumbnail,
	utvThumbnail,
} from '@common/components/images';

// ============================================================================
// Vehicle Category Metadata & Helpers
// ============================================================================

export const VEHICLE_CATEGORY_LABELS: Partial<Record<VehicleCategory, string>> = {
	[VehicleCategory.SXS]: 'Side-by-Side',
	[VehicleCategory.ATV]: 'ATV',
	[VehicleCategory.DUAL_SPORT]: 'Dual Sport',
	[VehicleCategory.MOTORCYCLE]: 'Motorcycle',
	[VehicleCategory.OFF_ROAD_MOTORCYCLE]: 'Off-Road Motorcycle',
	[VehicleCategory.SCOOTER]: 'Scooter',
	[VehicleCategory.E_BIKE]: 'E-Bike',
	[VehicleCategory.GOLFCART]: 'Golf Cart',
	[VehicleCategory.SNOWMOBILE]: 'Snowmobile',
	[VehicleCategory.PWC]: 'Personal Watercraft',
	[VehicleCategory.BOAT]: 'Boat',
	[VehicleCategory.UTV]: 'UTV',
	[VehicleCategory.MOPED]: 'Moped',
	[VehicleCategory.TRIKE]: 'Trike',
	[VehicleCategory.TRAILER]: 'Trailer',
	[VehicleCategory.CAR]: 'Car',
	[VehicleCategory.TRUCK]: 'Truck',
	[VehicleCategory.OTHER]: 'Other',
};

export const VEHICLE_CATEGORY_THUMBNAILS: Partial<Record<VehicleCategory, string>> = {
	[VehicleCategory.SXS]: orvThumbnail,
	[VehicleCategory.ATV]: atvThumbnail,
	[VehicleCategory.DUAL_SPORT]: dualSportThumbnail,
	[VehicleCategory.MOTORCYCLE]: motorcycleThumbnail,
	[VehicleCategory.OFF_ROAD_MOTORCYCLE]: dirtThumbnail,
	[VehicleCategory.SCOOTER]: scooterThumbnail,
	[VehicleCategory.GOLFCART]: golfThumbnail,
	[VehicleCategory.UTV]: utvThumbnail,
	[VehicleCategory.MOPED]: mopedThumbnail,
};

/**
 * Capitalizes the first letter of each word in a string
 */
export const capitalizeWords = (str: string): string => {
	return str
		.toLowerCase()
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
		.join(' ');
};

